import Box from "@material-ui/core/esm/Box";
import TextField from "@material-ui/core/esm/TextField";
import { nanoid } from 'nanoid';
import React from 'react';
import { Info, Subtitle } from 'components/Text/';
import useStyles from './FormStyles';
const idSuffix = nanoid();
export default function Input({
  children,
  label,
  autoFocus,
  editable,
  info,
  fullWidth,
  className,
  placeholder,
  error,
  helperText,
  onChange
}) {
  const {
    formStylesRoot,
    filledInput
  } = useStyles();
  const labelId = `${label}_${idSuffix}`;
  return /*#__PURE__*/React.createElement(Box, {
    my: 1,
    className: className
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 0.5,
    className: formStylesRoot
  }, label && /*#__PURE__*/React.createElement(Subtitle, {
    id: labelId
  }, label), info && /*#__PURE__*/React.createElement(Info, {
    align: "left"
  }, info)), /*#__PURE__*/React.createElement(TextField, {
    autoFocus: autoFocus,
    className: formStylesRoot,
    placeholder: placeholder,
    type: "text",
    fullWidth: fullWidth,
    "aria-labelledby": labelId,
    variant: editable ? 'outlined' : 'filled',
    value: children,
    InputProps: editable ? undefined : {
      readOnly: true,
      className: filledInput
    },
    error: error,
    helperText: helperText,
    onChange: e => onChange ? onChange(e.target.value) : null
  }));
}
Input.defaultProps = {
  children: '',
  label: null,
  info: null,
  editable: false,
  fullWidth: false,
  autoFocus: false,
  onChange: null,
  error: false,
  helperText: '',
  className: ''
};